<template>
<!-- 数字产业·设施农业 -->
  <div class="facility">
    <div
      v-for="(item, index) in facility"
      :key="index"
      :ref="item.res"
      :class="item.Class"
      @click="click_facility(item.Class, index, item.cont)"
    >
      {{ item.cont }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      facility: [
        {
          Class: "cont_dp",
          cont: "大棚种植区",
          res: "cont_dp",
          boolen_val:false
        },
        {
          Class: "cont_ss",
          cont: "设施农用地",
          res: "cont_ss",
          boolen_val:false
        },
      ],
    };
  },
  methods: {
    load() {
      var height = document.body.clientHeight / 2;
      $(".facility").css("top", height + "px");
    },
    click_facility: function (Class, e, name) {
      this.facility[e].boolen_val = !this.facility[e].boolen_val
      let vnt = this.facility[e].boolen_val
      let vn = !this.facility[e].boolen_val
      if(vnt){
        plMap.visibleDigitalIndustrial_LegendLayer(plMap.digitalIndustrial.curLayerId,e);
        $(".facility").children().css("border", "1px solid #fff");
        $("." + Class).css("border", "3px solid #f00");
        this.$set(this.facility, "boolen_val", false)
      }
      if(vn){
        plMap.visibleDigitalIndustrial_LegendLayer(plMap.digitalIndustrial.curLayerId,e);
        $(".facility").children().css("border", "1px solid #fff");
        this.$set(this.facility, "boolen_val", true);
        plMap.removeDigitalIndustrial_LegendLayer()
      }
      
    },
  },
  mounted: function () {
    this.load();
  },
};
</script>

<style scoped lang="less">
.facility {
  position: absolute;
  right: 1%;
  transform: translate(0, -50%);
}
.cont_dp,
.cont_ss {
  cursor: pointer;
  width: 66px;
  height: 30px;
  border: 1px solid #fff;
  margin: 5px 0;
  text-align: center;
  line-height: 30px;
  border-radius: 5px;
}
.cont_dp {
  background: url("../../assets/facility_agriculture/大棚种植区.png");
  background-size: 110% 100%;
  background-repeat: no-repeat;
}
.cont_ss {
  background: url("../../assets/facility_agriculture/设施农用地.png");
  background-size: 110% 100%;
  background-repeat: no-repeat;
}
</style>


// WEBPACK FOOTER //
// src/components/cutline/facility_agriculture.vue